export default "__VITE_ASSET__CESxAsSK__"